import { render, staticRenderFns } from "./SupplierOrderShow.vue?vue&type=template&id=706ff9d0"
import script from "./SupplierOrderShow.vue?vue&type=script&lang=js"
export * from "./SupplierOrderShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports